/* eslint-disable indent */
/* eslint-disable no-invalid-this */
/* eslint-disable no-empty-function */
import { getId } from '../../../utils/helperMethods';
import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LabelWrapper = styled.label`
    color: #5c5c5c;
    display: inline-block;
    font-size: 12px;
    margin-bottom: 15px;
    margin-right: 45px;
    position: relative;
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
`;

const InputWrapper = styled.input`
    cursor: pointer;
    opacity: 0;
    position: absolute;
`;

const CustomIconWrapper = styled.span`
    background: ${props => (props.isChecked ? '#ed7f31' : 'transparent')};
    background-size: cover;
    border: ${props =>
        props.isChecked ? '1px solid #ed7f31' : `1px solid #d2d3d5`};
    border-radius: 2px;
    display: inline-block;
    height: 18px;
    margin-right: 12px;
    width: 18px;

    &:after {
        border: 1px solid transparent;
        border-color: ${props =>
        props.isChecked
            ? `${props.isChanged ? '#f79714 !important' : '#fff'}`
            : 'transparent'};
        border-width: 0 1px 1px 0;
        content: '';
        display: block;
        height: 9px;
        left: 7px;
        position: absolute;
        transform: rotate(45deg);
        width: 4px;
        top: 2px;
    }
`;

const LabelTextWrapper = styled.span`
    display: inline-block;
    margin-top: 3px;
    text-decoration: ${props => (props.isPrevious ? 'line-through' : `none`)};
    vertical-align: top;
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 5px 0;
    /* text-transform: capitalize; */
`;

export const SingleCheckbox = props => {
    const {
        id,
        label = '',
        value = '',
        handleChange = () => { },
        isChecked = false,
        customClass = '',
        name = '',
        isDisabled = false,
        isPrevious = false,
        isChanged = false,
        isRequired = false,
        isSingleDisable = false,
        renderComponent,
    } = props;

    return (
        <React.Fragment>
            <LabelWrapper
                className={`label-wrap ${customClass} ${
                    isChecked ? 'selected ' : ''
                }${
                    renderComponent && isChecked ? 'small-margin' : ''
                }`
            }
                data-testid={getId(label)}
                isDisabled={isDisabled}
            >
                <InputWrapper
                    type="checkbox"
                    id={id}
                    data-testid={`input-${getId(label)}`}
                    name={name}
                    checked={isChecked}
                    onChange={handleChange}
                    value={value}
                    disabled={isDisabled || isSingleDisable}
                    required={isRequired}
                />
                <CustomIconWrapper
                    isChecked={isChecked}
                    isPrevious={isPrevious}
                    isChanged={isChanged}
                    className={`custom-icon ${isChecked ? 'selected' : ''}`}
                />
                {label && (
                    <LabelTextWrapper
                        className="check-label"
                        isPrevious={isPrevious}
                    >
                        {label}
                    </LabelTextWrapper>
                )}
            </LabelWrapper>
            {renderComponent && isChecked ? renderComponent : null}
        </React.Fragment>
    );
};

const Checkbox = props => {
    const {
        id,
        options = [],
        labelField = '',
        valueField = '',
        handleChange = () => { },
        input,
        meta,
        wrapperClass = '',
        customClass = '',
        isDisabled = false,
        isRequired = false,
        name = '',
        errorMessage = '',
        hideErrors,
        rePositionErrors,
        rePositionErrorsElement,
    } = props;

    const defaultSelected = useMemo(() => {
        if (options.length) {
            return options
                .filter(item => item.checked)
                .map(item => `${item[valueField]}`);
        }
        return [];
    }, [options, valueField]);

    const [selectedValues, setSelectedValues] = useState(
        input && input.value
            ? defaultSelected.concat(input.value)
            : defaultSelected
    );

    useEffect(() => {
        if (input && input.value) {
            setSelectedValues(defaultSelected.concat(input.value));
        } else if (defaultSelected && defaultSelected.length) {
            setSelectedValues(defaultSelected);
        } else {
            setSelectedValues([]);
        }
    }, [defaultSelected, input]);

    const captureSelectedBoxes = event => {
        const {
            target: { value },
        } = event;
        const selectedValuesState = [...selectedValues];
        if (selectedValues.includes(value)) {
            const indexValue = selectedValues.indexOf(value);
            selectedValuesState.splice(indexValue, 1);
        } else {
            selectedValuesState.push(value);
        }
        setSelectedValues(selectedValuesState);
        input && input.onChange(selectedValuesState);
        handleChange(selectedValuesState);
    };

    useEffect(() => {
        if (
            input &&
            input.value &&
            Array.isArray(input.value) &&
            selectedValues.sort().join('') !== input.value.sort().join('')
        ) {
            setSelectedValues(input.value);
            handleChange(input.value);
        }
    }, [handleChange, input, selectedValues]);
    return (
        <div className={wrapperClass}>
            {options.map((item, index) => (
                <React.Fragment key={index}>
                    <SingleCheckbox
                        id={id || getId(item[labelField])}
                        isPrevious={item.isPrevious || false}
                        isChanged={item.isChanged || false}
                        label={item[labelField]}
                        value={item[valueField]}
                        handleChange={event => captureSelectedBoxes(event)}
                        isChecked={selectedValues.includes(item[valueField])}
                        customClass={customClass}
                        isDisabled={isDisabled}
                        isSingleDisable={item.isSingleDisable}
                        isRequired={isRequired}
                        name={input && input.name ? input.name : name}
                        renderComponent={item.renderComponent}
                    />
                </React.Fragment>
            ))}
            {!hideErrors && !rePositionErrors && errorMessage && (
                <ErrorWrapper className="error-message">
                    {errorMessage}
                </ErrorWrapper>
            )}
            {!hideErrors && !rePositionErrors && meta && meta.touched && (
                <ErrorWrapper className="error-message">
                    {meta.error}
                </ErrorWrapper>
            )}
            {rePositionErrors &&
                rePositionErrorsElement &&
                errorMessage &&
                ReactDOM.createPortal(
                    <ErrorWrapper className="error-message">
                        {errorMessage}
                    </ErrorWrapper>,
                    rePositionErrorsElement
                )}
            {rePositionErrors &&
                rePositionErrorsElement &&
                meta &&
                meta.touched &&
                ReactDOM.createPortal(
                    <ErrorWrapper className="error-message">
                        {meta.error}
                    </ErrorWrapper>,
                    rePositionErrorsElement
                )}
        </div>
    );
};

Checkbox.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    labelField: PropTypes.string,
    valueField: PropTypes.string,
    id: PropTypes.string,
    handleChange: PropTypes.func,
    input: PropTypes.object,
    meta: PropTypes.object,
    wrapperClass: PropTypes.string,
    customClass: PropTypes.string,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    errorMessage: PropTypes.string,
    hideErrors: PropTypes.bool,
    rePositionErrors: PropTypes.bool,
    rePositionErrorsElement: PropTypes.element,
};

SingleCheckbox.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    handleChange: PropTypes.func,
    isChecked: PropTypes.bool,
    customClass: PropTypes.string,
    name: PropTypes.string,
    isPrevious: PropTypes.bool,
    isChanged: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    isSingleDisable: PropTypes.bool,
};

export default Checkbox;
